import type { ExpenseKind, ExpenseSource, PaymentStatus } from '@financiar/shared';
import { Tag } from 'antd';

export const KIND_LABELS: Record<ExpenseKind, string> = {
  INVOICE: 'Factură',
  RECEIPT: 'Bon fiscal',
  OTHER: 'Altele',
};

export const SOURCE_LABELS: Record<ExpenseSource, string> = {
  MANUAL: 'Manual',
  SPV: 'SPV',
  SMARTBILL: 'SmartBill',
  BANK: 'Bancă',
};

/** Same color language as the invoice list: green = money settled, orange =
 * partial, plain = still owed. */
export function ExpenseStatusTag({ status }: { status: PaymentStatus }) {
  if (status === 'PAID') return <Tag color="green">Plătită</Tag>;
  if (status === 'PARTIAL') return <Tag color="orange">Parțial plătită</Tag>;
  return <Tag color="blue">Neplătită</Tag>;
}

export function ExpenseKindTag({ kind }: { kind: ExpenseKind }) {
  const color = kind === 'INVOICE' ? 'geekblue' : kind === 'RECEIPT' ? 'cyan' : 'purple';
  return <Tag color={color}>{KIND_LABELS[kind]}</Tag>;
}

export function ExpenseSourceTag({ source }: { source: ExpenseSource }) {
  // Neutral: the source is provenance metadata, not a state to react to.
  return <Tag color="default">{SOURCE_LABELS[source]}</Tag>;
}
